<template>
  <div class="space-y-4">
    <!-- <div class="flex items-center justify-between">
      <button
        class="px-3 py-2 text-sm font-medium text-white bg-custom-yellow rounded-lg hover:bg-custom-yellow-dark"
        @click="fetchRecords"
      >
        Refresh
      </button>
    </div> -->

    <div v-if="isLoading" class="text-gray-500">Loading records...</div>
    <div v-else-if="errorMessage" class="text-red-500">{{ errorMessage }}</div>
    <div v-else-if="filteredRecords.length === 0" class="text-gray-500">
      No inventory records found.
    </div>

    <div v-else class="overflow-x-auto">
      <table class="min-w-full bg-white border border-gray-200 rounded-lg">
        <thead class="bg-gray-50 font-semibold">
          <tr>
            <th class="px-4 py-2 text-left">Item ID</th>
            <th class="px-4 py-2 text-left">Item Name</th>
            <th class="px-4 py-2 text-left">Item Type</th>
            <th class="px-4 py-2 text-left">Manufacturer</th>
            <th class="px-4 py-2 text-left">Quantity Received</th>
            <th class="px-4 py-2 text-left">Batch Number</th>
            <th class="px-4 py-2 text-left">Serial Number</th>
            <th class="px-4 py-2 text-left">Storage Location</th>
            <th class="px-4 py-2 text-left">Date Received</th>
            <th class="px-4 py-2 text-left">Expiry Date</th>
            <th class="px-4 py-2 text-left">Supplier</th>
            <th class="px-4 py-2 text-left">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(record, index) in filteredRecords"
            :key="record.id || record.inventory_record_id || index"
            class="border-t border-gray-200"
          >
            <td class="px-4 py-2 text-sm">{{ record.item_id || "-" }}</td>
            <td class="px-4 py-2 text-sm">{{ record.item_name || "-" }}</td>
            <td class="px-4 py-2 text-sm">{{ getItemTypeName(record.item_type) }}</td>
            <td class="px-4 py-2 text-sm">{{ record.manufacturer || "-" }}</td>
            <td class="px-4 py-2 text-sm">{{ record.quantity_received ?? "-" }}</td>
            <td class="px-4 py-2 text-sm">{{ record.batch_number || "-" }}</td>
            <td class="px-4 py-2 text-sm">{{ record.serial_number || "-" }}</td>
            <td class="px-4 py-2 text-sm">{{ record.storage_location || "-" }}</td>
            <td class="px-4 py-2 text-sm">{{ record.date_received || "-" }}</td>
            <td class="px-4 py-2 text-sm">{{ record.expiry_date || "-" }}</td>
            <td class="px-4 py-2 text-sm">{{ record.supplier || "-" }}</td>
            <td class="px-4 py-2 text-sm">
              <button
                class="bg-orange-400 text-white rounded-md font-medium px-3 py-1"
                @click="editRecord(record)"
              >
                Edit
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import api from "@/services/api";

// Simple in-memory cache to prevent table clearing if the tab component remounts
// (e.g., when opening the modal).
let inventoryRecordsCache = null;

export default {
  name: "InventoryRecordsTab",
  props: {
    searchQuery: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      records: [],
      itemTypes: [],
      isLoading: false,
      errorMessage: "",
    };
  },
  computed: {
    filteredRecords() {
      if (!this.searchQuery) return this.records;
      const q = this.searchQuery.toLowerCase();
      return this.records.filter((record) =>
        JSON.stringify(record).toLowerCase().includes(q)
      );
    },
  },
  methods: {
    getItemTypeName(itemTypeValue) {
      if (!itemTypeValue) return "-";
      const itemType = this.itemTypes.find(
        (type) =>
          type?.uuid === itemTypeValue ||
          type?.item_type_id === itemTypeValue ||
          type?.id === itemTypeValue
      );
      return itemType?.name || itemTypeValue;
    },
    editRecord(record) {
      this.$emit('edit-record', record);
    },
    async fetchItemTypes() {
      try {
        const response = await api.getItemTypes();
        this.itemTypes = Array.isArray(response)
          ? response
          : response?.data || response?.item_types || [];
      } catch (error) {
        console.error("Failed to fetch item types:", error);
      }
    },
    formatDateTime(value) {
      if (!value) return "-";
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return value;
      return date.toLocaleString();
    },
    async fetchRecords() {
      this.isLoading = true;
      this.errorMessage = "";
      try {
        const response = await api.getInventoryRecords();
        this.records = Array.isArray(response)
          ? response
          : response?.data || response?.inventory_records || [];
        inventoryRecordsCache = this.records;
      } catch (error) {
        this.errorMessage =
          error?.message || "Failed to fetch inventory records.";
      } finally {
        this.isLoading = false;
      }
    },
  },
  mounted() {
    this.fetchItemTypes();
    if (inventoryRecordsCache !== null) {
      this.records = inventoryRecordsCache;
      return;
    }
    this.fetchRecords();
  },
};
</script>
